import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { FooterDataState } from "../../../features/layouts/footerTypes";
import { getBannerInfo } from "./BannerApi";
import { BannerDataState } from "../../../features/view/public/landingPage/landingPageTypes";
const initialState: BannerDataState = {
  bannerData: { data: {}, loader: false },
};

export const getAdInfoAsync = createAsyncThunk("/orders/ad-list/", async () => {
  const response = await getBannerInfo();
  return response;
});

export const BannerSlice = createSlice({
  name: "banner",
  initialState,
  reducers: {},

  extraReducers: (builder) => {
    builder
      .addCase(getAdInfoAsync.pending, (state) => {
        state.bannerData.loader = true;
      })
      .addCase(getAdInfoAsync.fulfilled, (state, action: any) => {
        state.bannerData.loader = false;
        state.bannerData.data = action?.payload?.data || [];
      })
      .addCase(getAdInfoAsync.rejected, (state) => {
        state.bannerData.loader = false;
      });
  },
});

export default BannerSlice.reducer;
